import styles from "style/common/other/title.module.scss";

interface Props {
  text: string;
}

export default function Title({ text }: Props) {
  return <p className={styles.title}>{text}</p>;
}
